import React from 'react';
import _ListSocial from './_ListSocial.scss';

class ListSocialLeft extends React.Component {

  render() {
    return (
      <div className="list-social">
        
        <a href='' target='_blank' className='link-so-cong-thuong'><img src={require('assets/images/footer/so-cong-thuong.png')} alt='dang ki so cong thuong'/></a>
      </div>
    );
  }
}
export default ListSocialLeft;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/ListSocialLeft.jsx